/**
 * Яндекс.Метрика. Включается одной переменной окружения —
 * `NEXT_PUBLIC_METRIKA_ID` с номером счётчика. Пока её нет, ничего не
 * грузится и цели никуда не уходят, так что dev-контур статистику не пачкает.
 *
 * Админка живёт в другой группе маршрутов, поэтому счётчик до неё не достаёт.
 */

export const METRIKA_ID = process.env.NEXT_PUBLIC_METRIKA_ID

/**
 * Цели. В Метрике их нужно завести с этими же идентификаторами:
 * Счётчик → Настройка → Цели → «JavaScript-событие».
 */
export const GOALS = {
  /** Товар положили в корзину. */
  addToCart: 'add_to_cart',
  /** Человек открыл оформление с непустой корзиной. */
  checkoutStarted: 'checkout_started',
  /** Заказ оформлен — главная цель. */
  orderPlaced: 'order_placed',
  /** Просьба сообщить о поступлении размера. */
  restockRequested: 'restock_requested',
  /** Заявка на мероприятие со страницы услуг. */
  eventRequested: 'event_requested',
} as const

export type Goal = (typeof GOALS)[keyof typeof GOALS]

type Ym = (id: string | number, action: string, ...rest: unknown[]) => void

declare global {
  interface Window {
    ym?: Ym
  }
}

/** Отправить цель. Без счётчика — тихо ничего не делает. */
export function reachGoal(goal: Goal, params?: Record<string, unknown>): void {
  if (!METRIKA_ID || typeof window === 'undefined' || typeof window.ym !== 'function') return
  window.ym(METRIKA_ID, 'reachGoal', goal, params)
}

/** Отправить просмотр страницы — при переходах внутри приложения. */
export function reachPageView(url: string): void {
  if (!METRIKA_ID || typeof window === 'undefined' || typeof window.ym !== 'function') return
  window.ym(METRIKA_ID, 'hit', url)
}
